var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateForm',{model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},[_c('FormulateInput',_vm._b({attrs:{"id":_vm._.uniqueId('deep-field-')},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span')]},proxy:true}])},'FormulateInput',_vm.inputProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }